function Footer() {
	return (
		<footer className='w-full h-[45px] sm:h-[60px] bg-white mt-[60px] dark:bg-dark-300 flex items-center justify-center'>
			<p className='text-black dark:text-white'>
				2022 Все права защищены.
			</p>
		</footer>
	)
}

export default Footer
